import React from 'react';
import classes from "./SubscriptionProcessing.module.css";
import Layout from '../component/Layout';
import SubLayout from '../component/SubLayout';
import Header from '../component/Header';
import Container from '../component/Container';
import Lottie from 'lottie-react';
import waitAnimation from "../animations/waitAnimation.json";
import { FaArrowLeft } from 'react-icons/fa6';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const SubscriptionProcessing = () => {
    const navigate=useNavigate();
    const {t}=useTranslation();

    return (
        <Layout>
            <SubLayout>
                <Header hide={true} />

                    <div className={classes.container}>
                        <div className={classes.description}>
                            <h2 className={classes.title}>{t("27")}</h2>
                            <ul className={classes.list}>
                                <li className={classes.text}>
                                    {t("28")}
                                </li>
                                {/* <li className={classes.text}>
                            {t("123")}
                        </li> */}
                            </ul>

                            <div className={classes.animation_container}>
                                <Lottie animationData={waitAnimation} loop autoPlay className={classes.animation} />
                            </div>

                            <p className={classes.text2}>
                               {t("29")}
                            </p>

                            <div className={classes.center_button}>
                                <button type="button" className={classes.back_button} onClick={()=>navigate("/")}>
                                        <FaArrowLeft className={classes.back_icon} /> {t("30")}
                                </button>
                            </div>

                        </div>
                    </div>

            </SubLayout>
        </Layout>
    )
}

export default SubscriptionProcessing